import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { usePerson } from '../../context/PersonContext'
import Input from '../common/Input'
import Select from '../common/Select'
import { IconSave, IconUserPlus } from '../icons/Icons'
import ButtonPrimaryForm from '../common/ButtonPrimaryForm'

const PersonsForm = ({ person }) => {
    const [representative, setRepresentative] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        document: '',
        email: '',
        phone: '',
        address: '',
        representative: false,
        persons_type: ''
    })
    const [formRepresentative, setFormRepresentative] = useState({
        name: '',
        document: '',
        email: '',
        phone: '',
        address: '',
    })
    const ref = React.useRef();
    const MySwal = withReactContent(Swal)
    const {
        personsType,
        getPersonsType,
        createPersons,
        updatePersons,
        getPerson,
        getRepresentative,
    } = usePerson();

    useEffect(() => {
        getById(person)
        getPersonsType()
    }, [person])

    const getById = async (id) => {
        if (id !== null) {
            const resp = await getPerson(id)
            setFormData(() => ({
                name: resp.name,
                document: resp.document,
                email: resp.email,
                phone: resp.phone,
                address: resp.address,
                representative: resp.representative,
                persons_type: resp.persons_type_id
            }))
            const respRepre = await getRepresentative(id)
            if (respRepre.code === 200) {
                setRepresentative(true)
                setFormRepresentative(() => ({
                    name: respRepre.data.name,
                    document: respRepre.data.document,
                    email: respRepre.data.email,
                    phone: respRepre.data.phone,
                    address: respRepre.data.address,
                }))
            }
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(() => ({
            ...formData,
            [name]: value,
        }));
    }

    const handleInputRepresentativeChange = (e) => {
        const { name, value } = e.target;
        setFormRepresentative(() => ({
            ...formRepresentative,
            [name]: value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (person !== null) {
            const resp = await updatePersons(formData, person, formRepresentative, representative)
            MySwal.fire({
                title: resp.title,
                text: resp.msg,
                icon: resp.icon,
                customClass: {
                    confirmButton: 'btn-alert-primary',
                    cancelButton: 'btn-alert-danger',
                    title: 'title-alert',
                    htmlContainer: 'text-alert'
                },
            })
        } else {
            const resp = await createPersons(formData, formRepresentative, representative)
            MySwal.fire({
                title: resp.title,
                text: resp.msg,
                icon: resp.icon,
                customClass: {
                    confirmButton: 'btn-alert-primary',
                    cancelButton: 'btn-alert-danger',
                    title: 'title-alert',
                    htmlContainer: 'text-alert'
                },
            })
        }
    }

    const toggleRepresentative = () => {
        setRepresentative(!representative)
    }

    return (
        <>
            <div className='w-full flex flex-col md:flex-row items-center gap-4'>
                <button
                    className={`hover:bg-primary/90 border border-primary hover:text-white px-4 py-2 rounded-sm transition-colors duration-300 font-light flex items-center gap-1 ${representative ? 'bg-primary/90 text-white' : 'text-primary'}`}
                    onClick={toggleRepresentative}
                >
                    <IconUserPlus className='w-4' />
                    Representante
                </button>
            </div>
            <hr className='my-5' />
            <form onSubmit={handleSubmit} ref={ref}>
                <h4 className='uppercase text-sm font-medium mb-3'>Datos generales</h4>
                <div className='grid grid-cols-2 gap-4 mt-4 items-end'>
                    <Select
                        name={"persons_type"}
                        textLabel={'Tipo persona:'}
                        className='w-3/4'
                        value={formData.persons_type}
                        onChange={handleInputChange}
                        dataOptions={personsType}
                        required={true}
                    />
                    <Input
                        textLabel={'Nombres:'}
                        typeInput={"text"}
                        name={"name"}
                        className='w-3/4'
                        required={true}
                        value={formData.name}
                        onChange={handleInputChange}
                    />
                    <Input
                        textLabel={'Nro.documento:'}
                        typeInput={"text"}
                        name={"document"}
                        className='w-3/4'
                        required={true}
                        value={formData.document}
                        onChange={handleInputChange}
                    />
                    <Input
                        textLabel={'Email:'}
                        typeInput={"email"}
                        name={"email"}
                        className='w-3/4'
                        required={true}
                        value={formData.email}
                        onChange={handleInputChange}
                    />
                    <Input
                        textLabel={'Teléfono:'}
                        typeInput={"text"}
                        name={"phone"}
                        className='w-3/4'
                        value={formData.phone}
                        onChange={handleInputChange}
                    />
                    <Input
                        textLabel={'Dirección:'}
                        typeInput={"text"}
                        name={"address"}
                        className='w-3/4'
                        required={true}
                        value={formData.address}
                        onChange={handleInputChange}
                    />
                    <Select
                        textLabel={'Es representante?:'}
                        name={"representative"}
                        className='w-3/4'
                        value={formData.representative}
                        onChange={handleInputChange}
                        dataOptions={[
                            { name: 'Si', id: true },
                            { name: 'No', id: false }
                        ]}
                        required={true}
                    />

                </div>
                {
                    representative &&
                    <div className='mt-4'>
                        <h4 className='uppercase text-sm font-medium mb-3'>Representante Legal</h4>
                        <div className='grid grid-cols-2 gap-x-10 gap-y-2'>
                            <Input
                                textLabel={'Nombres:'}
                                typeInput={"text"}
                                name={"name"}
                                className='w-3/4'
                                required={true}
                                value={formRepresentative.name}
                                onChange={handleInputRepresentativeChange}
                            />
                            <Input
                                textLabel={'Nro.documento:'}
                                typeInput={"text"}
                                name={"document"}
                                className='w-3/4'
                                required={true}
                                value={formRepresentative.document}
                                onChange={handleInputRepresentativeChange}
                            />
                            <Input
                                textLabel={'Email:'}
                                typeInput={"email"}
                                name={"email"}
                                className='w-3/4'
                                required={true}
                                value={formRepresentative.email}
                                onChange={handleInputRepresentativeChange}
                            />
                            <Input
                                textLabel={'Teléfono:'}
                                typeInput={"text"}
                                name={"phone"}
                                className='w-3/4'
                                value={formRepresentative.phone}
                                onChange={handleInputRepresentativeChange}
                            />
                            <Input
                                textLabel={'Dirección:'}
                                typeInput={"text"}
                                name={"address"}
                                className='w-3/4'
                                value={formRepresentative.address}
                                onChange={handleInputRepresentativeChange}
                            />
                        </div>
                    </div>
                }
                <div className="flex justify-between items-center gap-2 mt-6">
                    <div className='flex flex-col gap-2'>
                        <span className='text-red-500 text-xs italic'>* Campos obligatorios</span>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <ButtonPrimaryForm text={'Guardar'} typeBtn={'submit'} >
                            <IconSave className='w-4' />
                        </ButtonPrimaryForm>
                    </div>
                </div>
            </form>
        </>
    )
}

export default PersonsForm